<template>
  <div class="metrics-charts-row">
    <metrics-score-chart :data="scoreData" :is-loading="isScoreLoading" />
    <metrics-ai-detection-chart
      :data="aiDetectionData"
      :is-loading="isAiDetectionLoading"
      :selected-type="aiDetectionType"
      :selected-metric="aiDetectionMetric"
      @update:selectedType="$emit('update:aiDetectionType', $event)"
      @update:selectedMetric="$emit('update:aiDetectionMetric', $event)"
    />
  </div>
</template>

<script>
import MetricsScoreChart from "./metrics_score_chart.vue";
import MetricsAiDetectionChart from "./metrics_ai_detection_chart.vue";

export default {
  name: "MetricsChartsRow",

  components: {
    MetricsScoreChart,
    MetricsAiDetectionChart,
  },

  props: {
    scoreData: {
      type: Object,
      required: true,
    },
    aiDetectionData: {
      type: Object,
      required: true,
    },
    isScoreLoading: {
      type: Boolean,
      default: false,
    },
    isAiDetectionLoading: {
      type: Boolean,
      default: false,
    },
    aiDetectionType: {
      type: String,
      default: "usedAI",
    },
    aiDetectionMetric: {
      type: String,
      default: "average",
    },
  },
};
</script>

<style lang="scss" scoped>
.metrics-charts-row {
  display: flex;
  gap: 16px;

  @media (max-width: 1100px) {
    flex-direction: column;
  }
}
</style>
